export const SET_PENDING_USERNAME = 'PAGE_SET_PENDING_USERNAME';
export const SET_PENDING_EMAIL = 'PAGE_SET_PENDING_EMAIL';
export const SET_PENDING_FULLNAME = 'PAGE_SET_PENDING_FULLNAME';
export const SET_PENDING_PASSWORD = 'PAGE_SET_PENDING_PASSWORD';
export const SET_PENDING_PASSWORD_CONFIRM = 'PAGE_SET_PENDING_PASSWORD_CONFIRM';
export const SET_ADDUSER_SAVING = 'PAGE_SET_ADDUSER_SAVING';
export const SET_INVITE_ERROR = 'PAGE_SET_INVITE_ERROR';
export const SET_INVITE_LOADING = 'PAGE_SET_INVITE_LOADING';

export function setPendingUsername(username) {
  return { type: SET_PENDING_USERNAME, username };
}

export function setPendingEmail(email) {
  return { type: SET_PENDING_EMAIL, email };
}

export function setPendingFullName(fullName) {
  return { type: SET_PENDING_FULLNAME, fullName };
}

export function setPendingPassword(password) {
  return { type: SET_PENDING_PASSWORD, password };
}

export function setPendingPasswordConfirm(passwordConfirm) {
  return { type: SET_PENDING_PASSWORD_CONFIRM, passwordConfirm };
}

export function setAddUserSaving(saving) {
  return { type: SET_ADDUSER_SAVING, saving };
}

export function setError(error) {
  return { type: SET_INVITE_ERROR, error };
}

export function setLoading(loading) {
  return { type: SET_INVITE_LOADING, loading };
}



// WEBPACK FOOTER //
// ./js/actions/page/Invites.js